import {Component} from '@angular/core';
// import { AppConfigService } from './app-config.service';

@Component({
  selector: 'sura-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor() {
  }
}
